import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * A mobile website video component.
 * @author Dayne Coulson-Hoffacker
 */
export default class MobileVideo {
  /**
   * Constructs a new MobileVideo.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    this.element = options.element
    this.video = this.element.querySelector('video')
    const self = this
    new Waypoint({
      element: self.element,
      handler: () => {
        self.element.classList.add('visible')
        self.video.play()
      },
      offset: '50%'
    })
  }
}



// WEBPACK FOOTER //
// ./components/mobile-video/index.js